module.exports = function ($sce, $timeout, settingsService, shopPageStateService, loadingIndicatorService, $state, pageMetadataService) {
    return {
        restrict: 'E',
        scope: {
            errorPage: '=',
            showIcon: '<',
            icon: '@',
            message: '@',
            secondaryMessage: '@',
            pageClass: '@',
            messageClass: '@',
            secondaryMessageClass: '@',
        },
        link(scope) {
            const currentState = $state.current.name;
            let previousMetadata;
            if (!previousMetadata) {
                previousMetadata = pageMetadataService.getCurrentMetadata();
            }

            if (!scope.message && !scope.secondaryMessage) {
                $timeout(() => {
                    settingsService.getSettingValue('ErrorPage', scope.errorPage).then((setting) => {
                        scope.errorPageContent = $sce.trustAsHtml(setting);
                        loadingIndicatorService.finishLoading();
                    });
                }, 500);
            }

            // If the user is on these error page for more than 20 seconds, then auto redirect to home page.
            const shouldRedirectToHomePage = function (stateName) {
                switch (stateName) {
                    case 'error.403':
                    case 'error.404':
                    case 'error.500':
                    case 'shop.recipes.recipenotfound':
                        return true;
                    default:
                        return false;
                }
            };
            const secondsToRedirectToHome = 20000;
            $timeout(() => {
                if (shouldRedirectToHomePage($state.current.name)) {
                    $state.go('root');
                }
            }, secondsToRedirectToHome);

            // center panel scroll top
            shopPageStateService.resetCenterPanelScroll();

            scope.$on('$destroy', () => {
                if (currentState === 'error.404') {
                    previousMetadata.meta404 = null;
                    pageMetadataService.setMetadata(previousMetadata);
                }
            });
        },
        template: require('./errorpage.directive.html').trim(),
    };
};



// WEBPACK FOOTER //
// ./src/common/errorpage/errorpage.directive.js